import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { tooltipTheme } from "../tooltipTheme";

interface TooltipBodyStyledProps {
    themeMode: RequiredThemeKeys;
}

export const TooltipBodyStyled = styled("div")<TooltipBodyStyledProps>`
    padding: var(--sds--tooltip--padding, ${({ themeMode }) => tooltipTheme.padding.body(themeMode)});

    // These are set to ensure the arrow calculations don't create an infinite loop due. See #468.
    min-height: 8px;
    min-width: 8px;

    *,
    a {
        color: ${({ themeMode }) => `var(--sds--tooltip--text-color, ${tooltipTheme.textColor.title(themeMode)})`};
    }
`;
